import { render, staticRenderFns } from "./TransCompanyPop.vue?vue&type=template&id=1b7f8c44&scoped=true"
import script from "./TransCompanyPop.vue?vue&type=script&lang=js"
export * from "./TransCompanyPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f8c44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b7f8c44')) {
      api.createRecord('1b7f8c44', component.options)
    } else {
      api.reload('1b7f8c44', component.options)
    }
    module.hot.accept("./TransCompanyPop.vue?vue&type=template&id=1b7f8c44&scoped=true", function () {
      api.rerender('1b7f8c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/TransCompanyPop.vue"
export default component.exports